import request from '../utils/request'
import QS from 'qs'

export function goodsList(data) {
  return request({
    url: '/api/goods',
    method: 'get',
    params: data
  })
}
export function goodsListDes(id, data) {
  return request({
    url: `/api/goods/${id}`,
    method: 'get',
    params: data
  })
}
export function getShopDes(id) {
  return request({
    url: `/api/shop/${id}`,
    method: 'get'
  })
}
// /api/poly/shop/{id}
export function getShop(id) {
  return request({
    url: `/api/poly/shop/${id}`,
    method: 'get'
  })
}
export function payPoly(data) { // 支付付款
  return request({
    url: '/api/poly/pay',
    method: 'post',
    data: QS.stringify(data)
  })
}
// /api/poly/pay
export function checkoutGoodsDes(id, data) { // 立即购买（单商品）结算
  return request({
    url: `/api/goods/${id}/checkout`,
    method: 'get',
    params: data
  })
}
export function supplierOrder(data) { // 生产供应商订单
  return request({
    url: `/api/goods/supplier/order`,
    method: 'post',
    data: QS.stringify(data)
  })
}

export function goodsCollect(id, data) {
  return request({
    url: `/api/goods/${id}/collect`,
    method: 'put',
    params: data
  })
}
export function shopCollect(id, data) {
  return request({
    url: `/api/shop/${id}/follow`,
    method: 'put',
    params: data
  })
}
export function addressList() {
  return request({
    url: '/api/user/address',
    method: 'get'
  })
}
export function addCart(data) {
  return request({
    url: '/api/cart',
    method: 'post',
    data: QS.stringify(data)
  })
}
export function addAddress(data) {
  return request({
    url: '/api/user/address',
    method: 'post',
    data: QS.stringify(data)
  })
}
export function addressEdit(id, data) {
  return request({
    url: `/api/user/address/${id}`,
    method: 'put',
    data: QS.stringify(data)
  })
}
export function addressDel(id) {
  return request({
    url: `/api/user/address/${id}`,
    method: 'delete'
  })
}
export function orderPay(data) {
  return request({
    url: '/api/goods/order',
    method: 'post',
    data: QS.stringify(data)
  })
}
export function orderPayMoney(id, type, data) {
  return request({
    url: `/api/payment/${id}/${type}`,
    method: 'post',
    data: QS.stringify(data)
  })
}
export function collectList(data) {
  return request({
    url: '/api/user/collect',
    method: 'get',
    params: data
  })
}
export function onePay() {
  return request({
    url: '/api/goods/onepay',
    method: 'get'
    // params:data,
  })
}
export function takeGood(id) {
  return request({
    url: `/api/user/order/${id}/take-goods`,
    method: 'put'
  })
}
export function goodsSku(id) {
  return request({
    url: `/api/trace-goods-specification/${id}`,
    method: 'get'
  })
}
export function discountCouponList(id) {
  return request({
    url: `/api/shop/${id}/bonus`,
    method: 'get'
  })
}

export function getDiscountCoupon(id) { // 领取优惠券
  return request({
    url: `/api/shop/${id}/bonus-get`,
    method: 'post'
  })
}
// /api/user/bonus
export function myBonusList(data) {
  return request({
    url: 'api/user/bonus',
    method: 'get',
    params: data
  })
}
// /api/user/bonus/redeem-code
export function redeemCode(data) { // 兑换优惠券
  return request({
    url: 'api/user/bonus/redeem-code',
    method: 'post',
    data: QS.stringify(data)
  })
}
// 门店优惠卷
// POST /api/shop/arrival-bonus
export function arrivalBonus(data) { // 门店优惠卷
  return request({
    url: '/api/shop/arrival-bonus',
    method: 'post',
    data: QS.stringify(data)
  })
}
// 创建付款订单
// POST /api/shop/arrival-order
export function arrivalOrder(data) { // 门店优惠卷
  return request({
    url: '/api/shop/arrival-order',
    method: 'post',
    data: QS.stringify(data)
  })
}

// 门店订单列表
// GET / api / arrival - order
export function arrivalOrderList(data) {
  return request({
    url: `/api/arrival-order`,
    method: 'get',
    params: data

  })
}
// 获取商品分享价格
// GET /api/goods/share_price/{id}
// 接口ID：44824915
// 接口地址：https://www.apifox.cn/web/project/413675/apis/api-44824915
export function getsharePrice(id) { // 领取优惠券
  return request({
    url: `/api/goods/share_price/${id}`,
    method: 'get'
  })
}
// 抽奖
// GET /api/turntable/winner/{id}/{type}
// 接口ID：45256029
// 接口地址：https://www.apifox.cn/web/project/413675/apis/api-45256029
// 类型 good：商品详情 order:订单下单

export function winner(data) { // 领取优惠券
  return request({
    url: `/api/turntable/winner/${data.id}/${data.type}`,
    method: 'get'
  })
}
// 奖品列表
// GET /api/turntable/prize/{id}/{type}
// 接口ID：45247236
// 接口地址：https://www.apifox.cn/web/project/413675/apis/api-45247236
// 类型 good：商品详情 order:订单下单
export function getTurntable(data) { // 领取优惠券
  return request({
    url: `/api/turntable/prize/${data.id}/${data.type}`,
    method: 'get'
  })
}
// 生成分享记录
// POST /api/goods/share_log
// 接口ID：45659896
// 接口地址：https://www.apifox.cn/web/project/413675/apis/api-45659896
export function goodsShareLog(data) { // 门店优惠卷
  return request({
    url: '/api/goods/share_log',
    method: 'post',
    data: QS.stringify(data)
  })
}
